import {
  call, put, takeEvery, takeLatest,
} from 'redux-saga/effects';
import { apiWithUrlParams } from '../apiMiddleware/apiMiddleware';
import * as types from '../constants';

function* getYesterdayTomorrow(action) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  let yesterdayDate = new Date(today);
  const yesterdayRef = new Date(yesterdayDate.setDate(today.getDate() - 1));
  const yesterdayMonthRef = (`0${(yesterdayRef.getMonth() + 1)}`).slice(-2);
  const yesterdayDayRef = (`0${yesterdayRef.getDate()}`).slice(-2);
  yesterdayDate = `${yesterdayRef.getFullYear()}${yesterdayMonthRef}${yesterdayDayRef}`;

  let tomorrowDate = new Date(today);
  const tomorrowRef = new Date(tomorrowDate.setDate(today.getDate() + 1));
  const tomorrowMonthRef = (`0${(tomorrowRef.getMonth() + 1)}`).slice(-2);
  const tomorrowDayRef = (`0${tomorrowRef.getDate()}`).slice(-2);
  tomorrowDate = `${tomorrowRef.getFullYear()}${tomorrowMonthRef}${tomorrowDayRef}`;

  try {
    const { data } = yield call(apiWithUrlParams, 'hubliveFavourites', 'getYesterdayTomorrow', action.urlParams);
    const yesterday = data[yesterdayDate];
    const tomorrow = data[tomorrowDate];
    if (Object.keys(yesterday).length) {
      yield put({ type: types.SET_YESTERDAY_SPORT, yesterday });
    }
    if (Object.keys(tomorrow).length) {
      yield put({ type: types.SET_TOMORROW_SPORT, tomorrow });
    }
  } catch (error) {
    yield put({ type: types.GET_YESTERDAY_TOMORROW_ERROR, error });
  }
}

function* getToday(action) {
  const urlParams = {
    date: action.date,
    id: action.sportId,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'hublive', 'getCompetitionsList', urlParams);
    yield put({ type: types.SET_TODAY_SPORT, data, sportId: action.sportId });
  } catch (error) {
    yield put({ type: types.GET_TODAY_ERROR, error });
  }
}

function* removeFavourites(action) {
  yield put({
    type: types.REMOVE_FAVOURITES_MATCH_FROM_LOCALSTORAGE, sportId: action.sportId, gameId: action.gameId, date: action.date,
  });
  yield put({
    type: types.UPDATE_FAVOURITES, sportId: action.sportId, gameId: action.gameId, date: action.date,
  });
}

function* watchGetYesterdayTomorrow() {
  yield takeLatest(types.GET_YESTERDAY_TOMORROW_REQUEST, getYesterdayTomorrow);
}

function* watchGetToday() {
  yield takeEvery(types.GET_TODAY_REQUEST, getToday);
}

function* watchRemoveFavourites() {
  yield takeEvery(types.REMOVE_FAVOURITES_MATCH, removeFavourites);
}

export default [
  watchGetYesterdayTomorrow,
  watchGetToday,
  watchRemoveFavourites,
];
